import React, {useRef, useState} from 'react'
import {useTranslation} from 'react-i18next'
import ColorPicker from '../ColorPicker'
import ColorCircle from '../Views/ColorCircle'

export const ViewColor = ({value, onChange}) => {
  const {t} = useTranslation()
  const [targetEl, setTargetEl] = useState(null)
  const ref = useRef(null)

  const handleToggle = () => {
    setTargetEl(ref.current)
  }
  return (
    <>
      <div ref={ref} style={{display: 'flex', alignItems: 'center'}}>
        <ColorCircle color={value} onClick={handleToggle} diameter={24} />
        <button className="ds-btn-secondary-small">{t('calendar.view.add.btn-color')}</button>
      </div>
      <ColorPicker
        targetEl={targetEl}
        onClose={e => setTargetEl(null)}
        value={value}
        onChange={onChange}
      />
    </>
  )
}
